import { ControlFileOverrides } from "../ControlFileOverrides";
import { CreditAndCollections } from "../CreditAndCollections";
import { CreditOverrides } from "../CreditOverrides";
import { FuelSurchargeOptions } from "../FuelSurchargeOptions";
import { OptionalSettings } from "../OptionalSettings";
import { Checkbox, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerOptions extends Layout {
    checkboxAutoTax: Checkbox;
    layoutControlFileOverrides: ControlFileOverrides;
    layoutCreditCollections: CreditAndCollections;
    layoutCreditOverrides: CreditOverrides;
    layoutCustomerOptions: OptionalSettings;
    layoutFuelSurchargeOptions: FuelSurchargeOptions;
    sourceCreditCalculations: DataSource;
    sourceCreditOverride: DataSource;
    sourceCustomer: DataSource;
    sourceCustomerFuelOptions: DataSource;
    tabCreditCollections: Tab;
    tabCreditOverrides: Tab;
    tabFuelSurcharge: Tab;
    tabOptionalSettings: Tab;
    tabOverrides: Tab;
    tabTaxes: Tab;
    tabsetOptions: Tabset;
    textboxBusinessNumber: Textbox;
    textboxExciseTaxable: Textbox;
    textboxQuebecNumber: Textbox;
}
